module.exports = __webpack_public_path__ + "images/513f76e25bd0eb6d438e26e7995f4cf4.gif";